var cifCn = ["301 201", "<g fill='none'><path fill='#DE2910' d='M.5.5h300v200H.5z'/><path fill='#FFDE00' d='M50.5 20.5l17.634 54.27-46.166-33.541h57.064L32.867 74.77zM91.925 25.645l12.488-14.348-1.67 18.948-9.786-16.31 17.505 7.443zM110.601 41.914l17.077-8.377-8.892 16.815-2.69-18.83 13.244 13.653zM110.885 67.753l19.009-.682-14.978 11.724 5.226-18.289 6.522 17.868zM92.691 84.253l17.798 6.711-18.343 5.032 11.882-14.853-.882 19z'/></g>"];

export { cifCn };

